import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useApp } from "@/App";
import { useTranslation } from "react-i18next";

export const Layout = ({ children, showBack = false, title = "" }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { haptic, isTelegramWebApp } = useApp();

  const handleBack = () => {
    haptic('light');
    navigate(-1);
  };

  return (
    <div className="flex flex-col h-[100dvh] overflow-hidden">
      {/* Шапка появляется, только если экрану нужен возврат или заголовок.
          Она размывает то, что под ней проезжает, — это одно из трёх мест,
          где блюр оправдан. Вместо сплошной границы снизу волосяная линия:
          сплошная режет сцену пополам. */}
      {(showBack || title) && (
        <header className="lp-bar lp-topbar sticky top-0 z-40 px-4 py-3 flex items-center gap-3">
          {showBack && !isTelegramWebApp && (
            <button
              onClick={handleBack}
              className="lp-press flex items-center gap-1 text-link font-medium"
              data-testid="back-button"
            >
              <ChevronLeft className="w-5 h-5" />
              {t('common.back')}
            </button>
          )}
          {title && (
            <h1 className="flex-1 text-center font-semibold">{title}</h1>
          )}
          {showBack && !isTelegramWebApp && <div className="w-16" />}
          <div className="lp-hair absolute inset-x-0 bottom-0 h-px" />
        </header>
      )}

      {/* Main content */}
      <main className="flex-1 overflow-y-auto">
        {children}
      </main>
    </div>
  );
};

export default Layout;
